<!--Weather widget-->
<div class="weather-content" [style.width]="'100%'" [style.height]="'100%'" #htmlContent>

    <!-- Mode chargement -->
    <app-widget-loading *ngIf="isLoading()" [graphType]="widget?.graphType"></app-widget-loading>

    <!-- Mode erreur -->
    <div *ngIf="error && !isLoading()" class="error-container">
        <span class="error">{{ error }}</span>
    </div>

    <!-- Contenu météo -->
    <div *ngIf="!isLoading() && !error && widgetData" class="weather-widget"
        [ngClass]="'weather-bg-' + weatherBackgroundType">

        <!-- Météo actuelle -->
        <div *ngIf="widgetDesign?.weatherOfTheDay?.showWeatherOfTheDay" class="current-weather">
            <div class="main-info">
                <div class="column-container"
                    [ngClass]="{'row-layout': widgetDesign?.weatherOfTheDay?.layout === 'row'}">

                    <!-- Section température -->
                    <div class="temperature-section">
                        <div class="location" *ngIf="widgetDesign?.weatherOfTheDay?.displayOptions?.includes('city')"
                            [style]="cityStyle">
                            {{ widgetData.city }}
                        </div>
                        <div class="temp-main"
                            *ngIf="widgetDesign?.weatherOfTheDay?.displayOptions?.includes('temperature')"
                            [style]="tempStyle">
                            {{ getRoundedTemp(widgetData.temperature) }}°
                        </div>
                    </div>

                    <!-- Section détails météo -->
                    <div class="weather-details">
                        <div class="weather-icon-section">
                            <img [src]="weatherIcon"
                                *ngIf="widgetDesign?.weatherOfTheDay?.displayOptions?.includes('icon')"
                                [alt]="widgetData.description" class="weather-icon" />
                            <div class="description"
                                *ngIf="widgetDesign?.weatherOfTheDay?.displayOptions?.includes('description')"
                                [style]="descriptionStyle">
                                {{ widgetData.description }}
                            </div>
                        </div>

                        <!-- Infos additionnelles (min/max + vent) -->
                        <div class="additional-info">
                            <div class="tempMinMax-section"
                                *ngIf="widgetDesign?.weatherOfTheDay?.displayOptions?.includes('minMax')">
                                <div class="temp">
                                    <mat-icon class="arrow">arrow_downward</mat-icon>
                                    {{ getRoundedTemp(widgetData.tempMin) }}°
                                </div>
                                <div class="temp">
                                    <mat-icon class="arrow">arrow_upward</mat-icon>
                                    {{ getRoundedTemp(widgetData.tempMax) }}°
                                </div>
                            </div>

                            <div class="wind-section"
                                *ngIf="widgetDesign?.weatherOfTheDay?.displayOptions?.includes('wind')">
                                <div class="wind-speed">{{ formatWindSpeed(widgetData.windSpeed) }}</div>
                                <div class="wind-direction">
                                    <span class="wind-arrow" [style.transform]="getWindDirectionIcon()">↑</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Infos supplémentaires -->
                <div class="extra-info" *ngIf="widgetDesign?.weatherOfTheDay?.extraInfoOptions?.length">
                    <div class="info-grid">
                        <div class="info-item"
                            *ngIf="widgetDesign.weatherOfTheDay.extraInfoOptions.includes('humidity')">
                            <mat-icon class="info-icon">opacity</mat-icon>
                            <div class="info-content">
                                <span class="info-label">Humidité</span>
                                <span class="info-value">{{ widgetData.humidity }}%</span>
                            </div>
                        </div>

                        <div class="info-item"
                            *ngIf="widgetDesign.weatherOfTheDay.extraInfoOptions.includes('precipitation')">
                            <mat-icon class="info-icon">grain</mat-icon>
                            <div class="info-content">
                                <span class="info-label">Précipitations</span>
                                <span class="info-value">{{ getPrecipitation() }}</span>
                            </div>
                        </div>

                        <div class="info-item"
                            *ngIf="widgetDesign.weatherOfTheDay.extraInfoOptions.includes('pressure')">
                            <mat-icon class="info-icon">compress</mat-icon>
                            <div class="info-content">
                                <span class="info-label">Pression</span>
                                <span class="info-value">{{ widgetData.pressure }} hPa</span>
                            </div>
                        </div>

                        <div class="info-item"
                            *ngIf="widgetDesign.weatherOfTheDay.extraInfoOptions.includes('UVIndex')">
                            <mat-icon class="info-icon">wb_sunny</mat-icon>
                            <div class="info-content">
                                <span class="info-label">UV</span>
                                <span class="info-value">{{ getUVIndex() }}</span>
                            </div>
                        </div>

                        <div class="info-item"
                            *ngIf="widgetDesign.weatherOfTheDay.extraInfoOptions.includes('visibility')">
                            <mat-icon class="info-icon">visibility</mat-icon>
                            <div class="info-content">
                                <span class="info-label">Visibilité</span>
                                <span class="info-value">{{ formatVisibility(widgetData.visibility) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Prévisions météo -->
        <div *ngIf="(displayMode === 'both' || displayMode === 'forecast') && widgetDesign?.forecast?.forecastType !== 'none'"
            class="forecast-section" [class.forecast-only]="!widgetDesign?.weatherOfTheDay?.showWeatherOfTheDay">
            <div class="forecast-header">
                <span>{{ widgetDesign.forecast.forecastType === 'hourly' ? 'Prochaines heures' : 'Prochains jours'
                    }}</span>
            </div>

            <!-- Prévisions horaires -->
            <div class="forecast-content" *ngIf="widgetDesign.forecast.forecastType === 'hourly'">
                <div class="hourly-forecast-carousel" *ngIf="hourlyForecastData.length; else noForecastData">
                    <div class="hourly-item"
                        *ngFor="let hourData of hourlyForecastData; let i = index; trackBy: trackByHour"
                        [class.current-hour]="i === 0">

                        <!-- Heure -->
                        <div class="hour-label">
                            {{ i === 0 ? 'Maint.' : formatHour(hourData.time) }}
                        </div>

                        <!-- Icône météo -->
                        <div class="weather-icon-container" *ngIf="widgetDesign.forecast?.showHourlyIcon">
                            <img [src]="i === 0 ? weatherIcon : hourData.iconUrl"
                                [alt]="i === 0 ? widgetData.description : hourData.description"
                                class="forecast-weather-icon" />
                        </div>

                        <!-- Température -->
                        <div class="hour-temp">
                            {{ i === 0 ? getRoundedTemp(widgetData.temperature) : getRoundedTemp(hourData.temperature)
                            }}°
                        </div>

                        <!-- Infos supplémentaires (optionnel) -->
                        <div class="hour-details" *ngIf="widgetDesign.forecast?.showHourlyDetails">
                            <div class="hour-humidity" *ngIf="hourData.humidity">{{ hourData.humidity }}%</div>
                            <div class="hour-precip" *ngIf="hourData.precipMm > 0">{{ hourData.precipMm }}mm</div>
                        </div>
                    </div>
                </div>

                <!-- Template pour les données manquantes -->
                <ng-template #noForecastData>
                    <div class="forecast-placeholder">
                        <mat-icon>schedule</mat-icon>
                        <span>Aucune prévision disponible</span>
                    </div>
                </ng-template>
            </div>

            <!-- Prévisions journalières -->
            <div class="forecast-content" *ngIf="widgetDesign.forecast.forecastType === 'daily'">
                <div class="daily-forecast-carousel" *ngIf="dailyForecastData.length; else noDailyForecastData">
                    <div class="daily-item"
                        *ngFor="let dayData of getDailyForecast(); let i = index; trackBy: trackByDay">

                        <!-- Date -->
                        <div class="day-label">
                            {{ i === 0 ? 'Auj. ' + formatDay(dayData.date).split(' ')[1] : formatDayShort(dayData.date)
                            }}
                        </div>

                        <!-- Icône météo -->
                        <div class="weather-icon-container" *ngIf="widgetDesign.forecast?.showDailyIcon !== false">
                            <img [src]="dayData.iconUrl" [alt]="dayData.description" class="forecast-weather-icon" />
                        </div>

                        <!-- Températures min/max -->
                        <div class="day-temps" *ngIf="widgetDesign.forecast?.showMinMax">
                            <span class="temp-min">{{ getRoundedTemp(dayData.tempMin) }}°</span>
                            <span class="temp-separator"> / </span>
                            <span class="temp-max">{{ getRoundedTemp(dayData.tempMax) }}°</span>
                        </div>

                        <!-- Vent -->
                        <div class="day-wind" *ngIf="widgetDesign.forecast?.showDailyWind !== false">
                            <span class="wind-arrow-daily">{{ getWindDirectionArrow(dayData.windDirection) }}</span>
                            <span class="wind-speed-daily">{{ formatDailyWindSpeed(dayData.windSpeed) }}</span>
                        </div>
                    </div>
                </div>

                <!-- Template pour les données manquantes -->
                <ng-template #noDailyForecastData>
                    <div class="forecast-placeholder">
                        <mat-icon>date_range</mat-icon>
                        <span>Aucune prévision journalière disponible</span>
                    </div>
                </ng-template>
            </div>
        </div>

    </div>
</div>